import React from 'react';

import QuestionShell from '../QuestionShell';
import useQuestionForm from '../QuestionShell/useQuestionForm';

function LongAnswer({
  identifier, pages, info, handleDeleteQuestion, handleDuplicateQuestion,
  mode, setPages,
}) {
  const question = useQuestionForm({
    identifier, pages, info, setPages, writeVia: 'setPages',
  });

  return (
    <QuestionShell
      {...question}
      identifier={identifier}
      info={info}
      mode={mode}
      titleKey="task.taskEdition.longAnswerText.question"
      descriptionKey="task.taskEdition.longAnswerText.description"
      handleDeleteQuestion={handleDeleteQuestion}
      handleDuplicateQuestion={handleDuplicateQuestion}
    />
  );
}

export default LongAnswer;
